import { ModuleKind } from "src/clients/flow-api";
import { useIsModuleEnabled } from "src/hooks/useIsModuleEnabled";

// Checks only whether the agents module is deployed on the workspace,
// independent of the `feature_flag_tktl_agents` Agent Builder gate that
// `useIsAgentsBuilderFeatureEnabled` also inspects. Use this for features
// (e.g. Copilot) that depend on the agents runtime but not on the Builder
// UI flag.
export const useIsAgentsModuleEnabled = (): { isEnabled: boolean } => {
  return useIsModuleEnabled(ModuleKind.AGENTS);
};
